module.exports = __webpack_public_path__ + "static/media/lave-linge.3f87a072.svg";